import * as React from 'react';
import { observer } from 'mobx-react';
import PieChart from 'react-minimal-pie-chart';
import { classes } from '../../utils/Classes';
import { MPP_SHADE_SELECT } from '../../constants/DataTestIdAttributes';
import { Shade } from '../../domain/entities/Shade';
import { Body1 } from 'elc-typography';
import { ShadeCircle, AbsoluteShadeWrapper } from './ProductShadeImageStyles';

export interface IShadeImage {
    className?: string;
    isSelected: boolean;
    onSelect(name: string, productId: string): void;
    productId: string;
    shade: Shade;
}

@observer
export class ProductShadeImage extends React.Component<IShadeImage> {
    private handleClick = () => {
        const { onSelect, shade } = this.props;
        const { name } = shade;
        if (onSelect) {
            onSelect(name, this.props.productId);
        }
    };

    public render() {
        const { isSelected, shade, className } = this.props;
        const { hexVal, name, isNameInsideShadeCircle, inventoryStatus } = shade;
        let { colors } = shade;
        const inventoryStatusClass = inventoryStatus
            ? classes(`status-${inventoryStatus.replace(/\s/g, '-').toLocaleLowerCase()}`)
            : '';

        const shadeClassNames = classes(
            'shade-image',
            className,
            isSelected ? 'elc-shade-image-selected' : '',
            isNameInsideShadeCircle ? 'elc-shade-circle-large' : '',
            inventoryStatusClass
        );

        const shadeNameInsideShadeClass = classes('shade-name-inside-shade');

        if (!colors || colors.length === 0) {
            colors = [hexVal];
        }
        const data = colors.map(color => ({ value: 1, color }));

        return (
            <ShadeCircle
                className={shadeClassNames}
                onClick={this.handleClick}
                data-test-id={MPP_SHADE_SELECT}
            >
                <AbsoluteShadeWrapper>
                    <PieChart data={data} />
                    {isNameInsideShadeCircle && (
                        <Body1 className={shadeNameInsideShadeClass}>{name}</Body1>
                    )}
                </AbsoluteShadeWrapper>
            </ShadeCircle>
        );
    }
}
